export default __webpack_public_path__ + "static/media/Login_Background.b150c6cf.jpg";